import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StoreService {
    address = '12 calle 2-47 zona 9';
    email = 'tiendaenlinea@veterinarialasemilla.com';
    phone = ['(502) 22012700'];
    hours = 'Lun-Vie 8:00am - 5:00pm';

    get primaryPhone(): string|null {
        return this.phone.length > 0 ? this.phone[0] : null;
    }

    constructor() { }
}
